import React, { useState, memo } from 'react';
type FAQItemProps = {
  question: string;
  answer: React.ReactNode;
  icon: React.ReactNode;
};
const FAQItem = ({
  question,
  answer,
  icon
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden mb-4 shadow-sm" data-id="element-40">
      <button className="w-full text-left p-4 flex items-start gap-3 bg-white hover:bg-gray-50 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-41">
        <div className="flex-shrink-0 text-blue-700 mt-0.5" data-id="element-42">{icon}</div>
        <div className="flex-grow" data-id="element-43">
          <h3 className="text-lg font-medium text-gray-900 pr-8 relative" data-id="element-44">
            {question}
            <span className="absolute right-0 top-1" data-id="element-45">
              <svg className={`w-5 h-5 text-gray-500 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-46">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-47" />
              </svg>
            </span>
          </h3>
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-48">
        <div className="p-4 pt-0 pl-14 bg-white text-gray-700" data-id="element-49">{answer}</div>
      </div>
    </div>;
};
export const FAQ = () => {
  return <div className="py-16 bg-gray-50 relative" data-id="element-50">
      {/* Stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-51">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-52"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-53">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-54">
          <span className="text-blue-700 mr-2" data-id="element-55">★</span>
          Frequently Asked Questions
          <span className="text-red-700 ml-2" data-id="element-56">★</span>
        </h2>
        <div className="mb-12" data-id="element-57">
          <FAQItem question="When will I receive my order?" answer={<ul className="space-y-2" data-id="element-59">
                <li data-id="element-60">Digital copies: Instant access right after checkout.</li>
                <li data-id="element-61">
                  Physical & Premium Hardcover: Ships in approximately 14
                  business days.
                </li>
                <li data-id="element-62">Collector's Bundle: Priority shipping included.</li>
              </ul>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-63">
                <path d="M4 10V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M4 10H2m18 0h2M4 10l2 9h12l2-9" data-id="element-64" />
                <path d="M14 2v4a2 2 0 1 1-4 0V2" data-id="element-65" />
              </svg>} data-id="element-58" />
          <FAQItem question="What payment methods do you accept?" answer={<p data-id="element-67">
                We accept all major credit/debit cards, PayPal, and secure
                payments.
              </p>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-68">
                <rect width="20" height="14" x="2" y="5" rx="2" data-id="element-69" />
                <line x1="2" x2="22" y1="10" y2="10" data-id="element-70" />
              </svg>} data-id="element-66" />
          <FAQItem question="Is this book only for conservatives?" answer={<p data-id="element-72">
                No. This book documents the cultural impact of Charlie Kirk's
                voice and message. Whether you admire or oppose him, it offers a
                real look at how one voice shaped a movement.
              </p>} icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-73">
                <rect x="2" y="2" width="20" height="20" rx="2" data-id="element-74" />
                <path d="M2 7h20M2 12h20M2 17h20" data-id="element-75" />
                <rect x="2" y="2" width="10" height="10" fill="currentColor" fillOpacity="0.2" data-id="element-76" />
                <circle cx="6" cy="6" r="1" fill="currentColor" data-id="element-77" />
              </svg>} data-id="element-71" />
          <FAQItem question="What makes this book different?" answer={<p data-id="element-79">
                Unlike traditional political biographies, this is a
                quote-driven, commemorative work — a celebration of ideas and
                cultural turning points, not a policy manual.
              </p>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-80">
                <path d="M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10z" data-id="element-81" />
                <path d="M12 16v-4M12 8h.01" data-id="element-82" />
              </svg>} data-id="element-78" />
          <FAQItem question="What bonuses are included?" answer={<ul className="space-y-2" data-id="element-84">
                <li data-id="element-85">Digital: 1 exclusive bonus download.</li>
                <li data-id="element-86">Physical & Premium Hardcover: 3 bonuses.</li>
                <li data-id="element-87">Collector's Bundle: All bonuses + premium items.</li>
              </ul>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-88">
                <path d="M12 8l6-3-6-3v6" data-id="element-89" />
                <path d="m8 11 4 2 4-2" data-id="element-90" />
                <path d="M12 22V12" data-id="element-91" />
                <path d="m19 15-7 4-7-4" data-id="element-92" />
              </svg>} data-id="element-83" />
          <FAQItem question="Do you ship internationally?" answer={<p data-id="element-94">No, we currently don't ship internationally.</p>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-95">
                <circle cx="12" cy="12" r="10" data-id="element-96" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" data-id="element-97" />
                <path d="M2 12h20" data-id="element-98" />
              </svg>} data-id="element-93" />
          <FAQItem question="Can I gift this book?" answer={<p data-id="element-100">
                Yes. Great for patriotic gifts, graduations, or special
                occasions.
              </p>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-101">
                <path d="M20 12v10H4V12" data-id="element-102" />
                <path d="M2 7h20v5H2z" data-id="element-103" />
                <path d="M12 22V7" data-id="element-104" />
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" data-id="element-105" />
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" data-id="element-106" />
              </svg>} data-id="element-99" />
          <FAQItem question="What if I miss the launch offer?" answer={<p data-id="element-108">
                This is a limited run. Once the launch stock and discounts are
                gone, prices may increase — especially for Premium and
                Collector's Editions.
              </p>} icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" data-id="element-109">
                <circle cx="12" cy="12" r="10" data-id="element-110" />
                <polyline points="12 6 12 12 16 14" data-id="element-111" />
              </svg>} data-id="element-107" />
        </div>
      </div>
    </div>;
};